export const maxDialogHeight = 60;
export const minDialogHeight = 60;
export const propertyListHeight = maxDialogHeight - 20;

export const customerLevels = [
    {value:'sso-only', text: Lang.langGet("SSO Only")},
    {value:'endcustomer', text: Lang.langGet("End Customer")},
    {value:'dealer', text: Lang.langGet("Dealer")},
    {value:'distributor', text: Lang.langGet("Distributor")},
    {value:'support', text: Lang.langGet("Support")},
];

export const userTypes = [
    {value: 'default', text: Lang.langGet('Default')},
    {value: 'ldap', text: Lang.langGet('LDAP')},
    {value: 'external', text: Lang.langGet('External')},
    {value: 'linked', text: Lang.langGet('Linked')},
];

export const publishNotifications = [
    { value: 0, text: Lang.langGet('Active') },
    { value: 1, text: Lang.langGet('Inactive') }
];

export const tagSearchOptions = [
    { value: 0, text: Lang.langGet('All') },
    { value: 1, text: Lang.langGet('Single') }
];

export const timepickerModeOptions = [
    { value: 0, text: Lang.langGet('Use browser locale') },
    { value: 1, text: Lang.langGet('AM/PM') },
    { value: 2, text: Lang.langGet('24hr') }
];

export const translations = {
    atLeastOneProject: Lang.langGet(`At least one project has to be selected!`),
    exactlyOneProject: Lang.langGet('Exactly one project has to be selected!'),
    levels: Lang.langGet("User Level"),
    customerName: Lang.langGet("Customer Name"),
    customerExternalId: Lang.langGet("Customer ID"),
    failedModifyUser: Lang.langGet("Failed to modify user in database."),
    userAddedSuccessfully: Lang.langGet("User added successfully."),
    multiEditTitle: Lang.langGet("Multi Edit Users - Customer Info"),
    users: Lang.langChoice("User|Users", 2),
    cancel: Lang.langGet("Cancel"),
    ok: Lang.langGet("Yes"),
    userExistsTitle: Lang.langGet("Duplicate user"),
    ldapToggleLabel: Lang.langGet("LDAP"),
    firstName: Lang.langGet('First Name'),
    name: Lang.langGet('Name'),
    lastName: Lang.langGet('Last Name'),
    email: Lang.langGet('Email Address'),
    publishNotification: Lang.langGet('Publish Notifications'),
    tagSearch: Lang.langGet('Tag Search'),
    timepickerMode: Lang.langGet('Timepicker Mode'),
    retry: Lang.langGet('Retry'),
    currentlyManaged: Lang.langGet('Currently Managed Project'),
    language: Lang.langGet('Language'),
    general: Lang.langGet('General'),
    projects: Lang.langGet('Projects'),
    grouping: Lang.langGet('Grouping'),
    passwords: Lang.langGet('Passwords'),
    addNewUser: Lang.langGet('Add a new user'),
    editUser: Lang.langGet('Edit user'),
    completeSteps: Lang.langGet('Complete the steps to create a new user'),
    t_previous: Lang.langGet('Previous'),
    t_next: Lang.langGet('Next'),
    t_close: Lang.langGet('Close'),
    t_save: Lang.langGet('Save'),
    t_clear: Lang.langGet('Clear, start over'),
    t_createNew: Lang.langGet('Create another user'),
    t_confirm: Lang.langGet('Confirm Password'),
    t_password: Lang.langGet('Password'),
    dialogCancelTitleCreate: Lang.langGet('Cancel creating new user'),
    dialogCancelTitleEdit: Lang.langGet('Cancel editing user'),
    dialogCancelMessageCreate: Lang.langGet('Do you really want to stop creating a new user?'),
    dialogCancelMessageEdit: Lang.langGet('Do you really want to stop editing this user?'),
    project: Lang.langGet('Project'),
    usergroup: Lang.langGet('Usergroup'),
    privilegegroup: Lang.langGet('Privilegegroup'),
    processing: Lang.langGet('Processing...'),
    addUser: Lang.langGet("Add existing user"),
    confirmDeleteTOTP: Lang.langGet('Do you really want to deactivate the two factor authentication for this user?'),
    confirmDeleteTOTPTitle: Lang.langGet('Confirm deactivation'),
    setupTOTP: Lang.langGet('Two Factor Authentication'),
    deactivateSeed: Lang.langGet('Deactivate'),
}
